export enum ObjectTypeEnum {
  ENTITY = 'Entity',
  DEBUG_SESSION = 'Debug-Session',
  CONTINUOUS_DEBUG_SESSION = 'Continuous-Debug-Session',
  FLOW_METADATA = 'Flow-Metadata',
  PLATFORM_GROUP = 'Platform-Group',
}
